import { Expose } from "class-transformer";
import {
  IsBoolean,
  IsInt,
  IsOptional,
  IsString,
  Length,
  Max,
  Min,
} from "class-validator";

export class FindAllCountiesInput {
  @Expose()
  @IsOptional()
  @IsString()
  search?: string;

  @Expose()
  @IsOptional()
  @IsString()
  @Length(2, 2)
  stateFips?: string;

  @Expose()
  @IsOptional()
  @IsString()
  accountManagerId?: string;

  @Expose()
  @IsOptional()
  @IsBoolean()
  covered?: boolean;

  @Expose()
  @IsOptional()
  @IsInt()
  @Min(1)
  @Max(500)
  limit?: number;

  @Expose()
  @IsOptional()
  @IsInt()
  @Min(0)
  offset?: number;
}
